<template>
  <div class="input-group mb-2">
    <input v-if="searchMode"
      class="form-control"
      v-bind:class="{'is-invalid': !isValid && entityId }"
      name="entityId"
      v-bind:placeholder="searchModeObj[searchMode]['placeholder']"
      v-model="entityId"
      maxlength="10"
      inputmode="numeric"
      pattern="[0-9]*"
      @keyup.enter="navigateToRoute"
      @input="checkEntity"
      type="text"
    >
    <div class="input-group-append">
      <router-link
      :to="{ name: this.searchModeObj[this.searchMode].routeName, params: getParams() }"
      v-bind:class="{ disabled: !isValid || !entityId }"
      class="btn btn-secondary">
      Go
    </router-link>
    </div>
      <div class="invalid-feedback d-block">{{ entryError }}</div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'GoToEntityForm',
  props: {
    searchMode: {
      type: String,
      default: 'projectId',
    },
  },
  data() {
    return {
      serverError: null,
      entryError: '',
      entityId: null,
      projectId: null,
      isValid: true,
      searchModeObj: {
        projectId: {
          placeholder: 'Enter Project ID Number',
          fieldName: 'Project ID',
          entityType: 'Project',
          routeName: 'project',
        },
        instrumentId: {
          placeholder: 'Enter Instrument ID Number',
          fieldName: 'Instrument ID',
          entityType: 'Instrument',
          routeName: 'projectInstrument',
          paramName: 'id',
        },
        serviceId: {
          placeholder: 'Enter Service ID Number',
          fieldName: 'Service ID',
          entityType: 'Service',
          routeName: 'projectService',
          paramName: 'id',
        },
        propertyId: {
          placeholder: 'Enter Property ID Number',
          fieldName: 'Property ID',
          entityType: 'Property',
          routeName: 'projectProperty',
          paramName: 'property_id',
        },
      },
    };
  },
  methods: {
    checkEntity() {
      const self = this;
      if (!Number.isNaN(parseInt(this.entityId, 10))) {
        api.get(`/${this.searchModeObj[this.searchMode].entityType.toLowerCase()}/${this.entityId}/exists`)
          .then((response) => {
            self.projectId = response.data;
            if (self.projectId) {
              self.isValid = true;
              self.entryError = '';
            } else {
              self.isValid = false;
              self.entryError = `${this.searchModeObj[this.searchMode].entityType} not found.`;
            }
          });
        // need a refactor in here to pull in the project id correctly for non-project entities
      } else {
        this.isValid = false;
        if (this.entityId) {
          this.entryError = `The ${this.searchModeObj[this.searchMode].fieldName} field may only contain numeric characters.`;
        } else {
          this.entryError = '';
        }
      }
    },
    getParams() {
      const paramObj = { project_id: this.projectId };
      if (this.searchModeObj[this.searchMode].paramName) {
        paramObj[this.searchModeObj[this.searchMode].paramName] = parseInt(this.entityId, 10);
      }
      return paramObj;
    },
    navigateToRoute() {
      if (!this.isValid || !this.entityId) {
        return;
      }

      const { routeName } = this.searchModeObj[this.searchMode];
      const params = this.getParams();

      if (routeName) {
        this.$router.push({ name: routeName, params });
      }
    },
  },
};
</script>
